import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ConsentFields } from "@/components/checkins/client/EnrolDialog";
import { DueDatePicker, todayMelbourne } from "@/components/checkins/client/DueDatePicker";

export const emptyProgressReview = () => ({ start_date: todayMelbourne(), preferred_name: "", send_now: true,
  consent: { given: false, method: "verbal" } });

export const progressReviewBody = (pr) => ({
  start_date: pr.start_date, preferred_name: pr.preferred_name.trim() || null,
  send_now: pr.send_now && pr.start_date === todayMelbourne(), consent: pr.consent,
});

/** Start a digital diary / questionnaire from the library — Progress Review owns the schedule and link. */
export function ProgressReviewFields({ value, onChange, digital }) {
  const [wording, setWording] = useState("I agree to receive exercise progress review emails.");
  useEffect(() => { api.get("/checkin-settings").then((r) => r.data.consent_wording && setWording(r.data.consent_wording)).catch(() => {}); }, []);
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  const today = value.start_date === todayMelbourne();
  return (
    <div className="space-y-3" data-testid="send-progress-review-fields">
      <p className="text-xs text-zinc-600">
        {digital?.kind === "diary"
          ? `The client gets one private link for the ${digital.diary_days}-day diary, a mid-week reminder (they can turn it off) and you're flagged when it's sent or a flag rule is met.`
          : "Progress Review emails the client a private link and handles reminders and alerts."}
      </p>
      <div className="grid gap-3 sm:grid-cols-2">
        <div><Label className="text-xs">{digital?.kind === "diary" ? "Diary starts" : "Starts"}</Label><div className="mt-1"><DueDatePicker value={value.start_date} onChange={set("start_date")} testId="send-pr-start" /></div></div>
        <div><Label className="text-xs">Preferred name (optional)</Label>
          <Input className="mt-1" value={value.preferred_name} maxLength={60} onChange={(e) => set("preferred_name")(e.target.value)} data-testid="send-pr-preferred-name" /></div>
      </div>
      <ConsentFields wording={wording} consent={value.consent} setConsent={set("consent")} />
      {today ? (
        <label className="flex items-center gap-2 text-sm">
          <Checkbox checked={value.send_now} onCheckedChange={(v) => set("send_now")(!!v)} data-testid="send-pr-send-now" />
          Email the private link now
        </label>
      ) : <p className="text-xs text-zinc-500" data-testid="send-pr-scheduled-note">The private link is emailed at 9:00 am on the start date.</p>}
    </div>
  );
}
